module.exports = __webpack_public_path__ + "img/connect.bf8818a2.png";